/* German Language File */

var currentlanguage = 'de';

+function ($) {

	/* German translation for the jQuery dataTable Addon */
	if ('undefined' !== typeof $.fn.dataTable) {
		$.extend( true, $.fn.dataTable.defaults, {
			"oLanguage": {
				"sEmptyTable":      "Keine Daten in der Tabelle vorhanden",
				"sInfo":            "_START_ bis _END_ von _TOTAL_ Einträgen",
				"sInfoEmpty":       "0 bis 0 von 0 Einträgen",
				"sInfoFiltered":    "(gefiltert von _MAX_ Einträgen)",
				"sInfoPostFix":     "",
				"sInfoThousands":   ".",
				"sLengthMenu":      "_MENU_ Einträge anzeigen",
				"sLoadingRecords":  "Wird geladen...",
				"sProcessing":      "Bitte warten...",
				"sSearch":          "Suchen",
				"sZeroRecords":     "Keine Einträge vorhanden.",
				"oPaginate": {
				    "sFirst":       "Erste",
				    "sPrevious":    "Zurück",
				    "sNext":        "Nächste",
				    "sLast":        "Letzte"
				},
				"oAria": {
				    "sSortAscending":  ": aktivieren, um Spalte aufsteigend zu sortieren",
				    "sSortDescending": ": aktivieren, um Spalte absteigend zu sortieren"
				}
			}
		});
	}

	// Extra APT validator translations
	if ('undefined' !== typeof $.validator) $.extend($.validator.messages, {
		// Extra for apt
		credit_limit: "The credit limit should be between 250k and 150M.",
		grace_holiday_period: "The grace period should be lower than the term in months.",
		term_grace_leasing: "The term minus grace period should always be a multiple of payment frequency.",
		max_term_leasing: "The term minus grace period should not exceed 240 months (20 years).",
		max_term_factoring: "The term should not exceed 1200 months (100 years).",
		net_principal_amount: "The sum of down payment and residual value should be lower than the net principle amount.",
		zero: "This field must be greater than zero."
	});

}(jQuery);
